import { store } from "../redux"

export const getOrganizationNameFromRoute = () => {
  const organizationName = store.getState().global.organization

  if (!organizationName || organizationName === "setting" || organizationName === "organization") return ""

  return organizationName
}
